import { OperatorInlineImage } from '../OperatorInlineImage'
import type { OperatorLogoBlobRef } from '../platform/buxus/operatorLogo'

type OperatorPageHeaderLogoProps = {
  operatorId: string
  logoUrl: string | null
  logoBlob: OperatorLogoBlobRef | null
  operatorName: string
}

/** Operator logo in the page header (SAS URL or legacy downloaded blob). */
export function OperatorPageHeaderLogo({
  operatorId,
  logoUrl,
  logoBlob,
  operatorName,
}: OperatorPageHeaderLogoProps) {
  if (logoUrl) {
    return (
      <img
        src={logoUrl}
        alt=""
        className="page-header-logo"
        referrerPolicy="no-referrer"
        loading="lazy"
      />
    )
  }

  if (logoBlob && operatorId) {
    return (
      <OperatorInlineImage
        operatorId={operatorId}
        fileId={logoBlob.fileId}
        fileExt={logoBlob.fileExt}
        alt={`${operatorName} logo`}
        className="page-header-logo"
        hideFallback
      />
    )
  }

  return null
}
